/**
 * Text as a search compares it: lower case, without accents ("Synthèse" reads
 * "synthese"). The one rule for every search and its highlight
 * (`lib/highlight.ts`), so what a search finds is what it marks.
 */
export function searchable(text: string): string {
  return text
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}

/**
 * Whether a row matches a search typed in a filter row: every word of the
 * search in any of the row's texts (a name, an email, a summary), in any
 * order, ignoring case and accents. An empty search matches every row; a
 * missing text is skipped.
 */
export function matchesSearch(
  texts: readonly (string | null | undefined)[],
  query: string,
): boolean {
  const haystack = searchable(texts.filter(Boolean).join(" "));
  return searchable(query)
    .trim()
    .split(/\s+/)
    .every((word) => haystack.includes(word));
}
